import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useMultiParentlessResourceAdapterActions } from '../../../resource-base/adapters/useMultiParentlessResourceAdapterActions';
import { IdSchema } from '../../../resource-base/baseSchemas';
import {
    defaultNamedPersistableResource,
    NamedPersistableResourceSchema,
} from '../../../resource-base/persistableResourceTypes';

export enum SystemUserGroupPropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    USERS = 'USERS',
    SYSTEM_USER_GROUPS = 'SYSTEM_USER_GROUPS',
    USER_WILDCARD_MATCHER = 'USER_WILDCARD_MATCHER',
}

export const SystemUserGroupResourceSchema = NamedPersistableResourceSchema.extend({
    description: z.string(),
    users: IdSchema.array(),
    systemUserGroups: IdSchema.array(),
    userWildcardMatcher: z.string().nullable(),
    resourceType: z.literal(ResourceType.SYSTEM_USER_GROUP).default(ResourceType.SYSTEM_USER_GROUP),
});

export const SystemUserGroupMutationResourceSchema = getMutationSchema(SystemUserGroupResourceSchema);

export type SystemUserGroupResource = z.infer<typeof SystemUserGroupResourceSchema>;

export const defaultSystemUserGroupResource: SystemUserGroupResource = {
    ...defaultNamedPersistableResource,
    resourceType: ResourceType.SYSTEM_USER_GROUP,
    description: '',
    users: [],
    systemUserGroups: [],
    userWildcardMatcher: null,
};

export function useSystemUserGroupActions() {
    return useMultiParentlessResourceAdapterActions(
        'system-user-group',
        ResourceType.SYSTEM_USER_GROUP,
        SystemUserGroupResourceSchema
    );
}
